export default __webpack_public_path__ + "static/media/avi_agrawal-rocmob.c21f8a8c.png";